export default {"src":"/_next/static/media/django.49c56ef8.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};